var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TipsNews"},[_c('top-bar',{attrs:{"title":"收费标准","hasBack":""}}),_c('div',{staticClass:"content"},[_vm._v(" 测试内容 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }